import {useSelector} from '@xstate/react';

import {RootMachineContext} from '../machines/rootMachine';


export const useRootMachine = () => {
  const rootActor = RootMachineContext.useActorRef();
  const rootState = useSelector(rootActor, (state) => state);
  return {
    rootActor,
    rootState,
  };
};
